import { HelpCircle, Inbox, Mail, MessageCircle, Smartphone } from "lucide-react";

import { NotificacaoCanal, NotificacaoCanalMap, StatusEnvioNotificacao } from "@workflow/types";
import { ChartConfig } from "@/components/ui/chart";
import { cn } from "@/lib/utils";

/** Config visual (ícone + cor) compartilhada entre os cards de métrica e os gráficos de envios por canal. */
export const CANAL_CONFIG: Record<
  NotificacaoCanal,
  { icon: typeof Mail; className: string; barClassName: string }
> = {
  [NotificacaoCanal.EMAIL]: {
    icon: Mail,
    className: "border-blue-500/20 bg-blue-500/[0.07] text-blue-700 dark:text-blue-300",
    barClassName: "bg-blue-500",
  },
  [NotificacaoCanal.WHATSAPP]: {
    icon: MessageCircle,
    className: "border-emerald-500/20 bg-emerald-500/[0.07] text-emerald-700 dark:text-emerald-300",
    barClassName: "bg-emerald-500",
  },
  [NotificacaoCanal.SMS]: {
    icon: Smartphone,
    className: "border-violet-500/20 bg-violet-500/[0.07] text-violet-700 dark:text-violet-300",
    barClassName: "bg-violet-500",
  },
  [NotificacaoCanal.INBOX]: {
    icon: Inbox,
    className: "border-amber-500/20 bg-amber-500/[0.07] text-amber-700 dark:text-amber-300",
    barClassName: "bg-amber-500",
  },
};

export const CANAL_DESCONHECIDO_CONFIG = {
  icon: HelpCircle,
  className: "border-border/60 bg-muted text-muted-foreground",
  barClassName: "bg-muted-foreground/40",
};

export const STATUS_CHART_CONFIG = {
  [StatusEnvioNotificacao.ENVIADA]: { label: "Enviada", color: "#10b981" },
  [StatusEnvioNotificacao.FALHA]: { label: "Falha", color: "#ef4444" },
  [StatusEnvioNotificacao.IGNORADA]: { label: "Ignorada", color: "#f59e0b" },
} satisfies ChartConfig;

export function CanalBadge({ canal, count }: { canal: string; count: number }) {
  const config = CANAL_CONFIG[canal as NotificacaoCanal] ?? CANAL_DESCONHECIDO_CONFIG;
  const label = NotificacaoCanalMap[canal as NotificacaoCanal] ?? "Outro";
  const Icon = config.icon;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md border py-1 pl-1.5 pr-2 text-[11px] font-medium",
        config.className,
      )}
    >
      <Icon className="h-3 w-3 shrink-0 opacity-70" />
      {label}
      <span className="font-semibold">{count}</span>
    </span>
  );
}
